import {useSelector} from 'react-redux';

import {createUrlFromNutshellFilterObject} from 'nutshell-core';

import type {FilterObject} from 'nutshell-core/types';

import {DEFAULT_FIELDS_MCFXCOMPANIES} from '../../../reports/report-constants';

import type {NutshellState} from '../../../../store';

import * as selectors from '../companies-list/companies-selectors';

export const useGetFilteredCompaniesListUrlPath = (): ((filter: FilterObject) => string) => {
    const mcfxCompaniesSchema = useSelector((state: NutshellState) =>
        selectors.getMcfxCompaniesSchema(state)
    );

    return (filter: FilterObject) => {
        let filterString = createUrlFromNutshellFilterObject(filter, mcfxCompaniesSchema);

        if (filterString) {
            filterString = '&'.concat(filterString);
        }

        return `/email-marketing/visitors/list?fields[mcfxcompanies]=${DEFAULT_FIELDS_MCFXCOMPANIES}${filterString}&persist=false`;
    };
};
